/**
 * Browse details/compare re-quote Med Supp through SunFire. Those pages must
 * use the member's stored DOB — premiums are age-rated. A hardcoded "age 65
 * on Jan 1" quote does not match Pathfinder recommendations.
 */
const FALLBACK_MED_SUPP_AGE = 65;

export function fallbackMedSuppBirthday(now = new Date()): Date {
  return new Date(Date.UTC(now.getUTCFullYear() - FALLBACK_MED_SUPP_AGE, 0, 1));
}

export function parseMedSuppBirthday(
  birthdate: string | Date | null | undefined,
  now = new Date()
): Date {
  if (birthdate instanceof Date && !Number.isNaN(birthdate.getTime())) {
    return birthdate;
  }

  if (typeof birthdate === 'string' && birthdate.trim() !== '') {
    const parsed = new Date(birthdate);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return fallbackMedSuppBirthday(now);
}

export function medSuppQuoteParamsFromUser(
  user?: {
    birthdate?: string | Date | null;
    gender?: string | null;
    tobacco?: boolean | null;
  } | null
): { birthday: Date; gender: string; smoker: boolean } {
  return {
    birthday: parseMedSuppBirthday(user?.birthdate),
    gender: user?.gender || 'female',
    smoker: user?.tobacco === true,
  };
}
